// extracted by mini-css-extract-plugin
module.exports = {"controlButton":"_18CEU","hidden":"_3dhP2","loader":"_122Dk","rotate":"_3vWq3","active":"_27yKz","clip":"_3_-zy","clip-reverse":"_3cdRb","clipReverse":"_3cdRb"};